export const formatSectionSpecRevision = (
	revision: number | null,
	subRevision?: number | null,
): string => {
	if (revision === null) return "Rev pending";

	// Subrevisions are integer identifiers, not decimal places (7.10 differs from 7.1).
	return subRevision != null && subRevision > 0
		? `Rev ${revision}.${subRevision}`
		: `Rev ${revision}`;
};
